import type { ICurrencyDropDownItem } from 'BreetHelpers';
import { type ReactNode, useMemo, useState } from 'react';

import { WithdrawRequestContext } from '../context/FormContext';

export const WithdrawRequestProvider = ({ children }: { children?: ReactNode }) => {
	const [selectedWallet, setSelectedWallet] = useState<ICurrencyDropDownItem | undefined>();

	const providerValue = useMemo(
		() => ({
			selectWallet: setSelectedWallet,
			selectedWallet,
		}),
		[selectedWallet]
	);

	return <WithdrawRequestContext.Provider value={providerValue}>{children}</WithdrawRequestContext.Provider>;
};
